import { Chip } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import React, { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from 'store/index';
import { getOtherAppConfig } from 'utils/otherApp';

const OtherAppBadge = () => {
    const userId = useSelector((state: RootState) => state.user?.info?.id);
    const config = useMemo(() => getOtherAppConfig(), [userId]);

    if (!config?.url) return null;

    return (
        <Link to="/other-app">
            <Chip
                sx={{
                    ml: 0.5,
                    mr: 0.5,
                    cursor: 'pointer',
                    '& .MuiChip-icon': {
                        color: '#000080',
                    },
                }}
                label={
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <PublicIcon style={{ display: 'flex', color: '#000080', marginLeft: '5px' }} />
                        <span>{config.title}</span>
                    </div>
                }
                variant="outlined"
            />
        </Link>
    );
};

export default memo(OtherAppBadge);
